import { getCurrentUser } from "../../lib/auth_base/localstorage";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";
import CreateproductCategory from "./ui/create-category";




export default function NewCategory() {
  const user =  getCurrentUser()
  const categories = useFetchCategories()
  return (
    <CreateproductCategory
      categories={categories}
      is_admin={user && user.role === "admin" ? true : false}
      is_logged={user ? true : false}
      user={user}
    />
  );
}
